import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchUnitHeader from 'components/SearchUnitHeader/SearchUnitHeader';
import SearchUnitHotelNameLayout from 'layouts/SearchUnitHotelNameLayout/SearchUnitHotelNameLayout';
import * as searchUnitActions from 'actions/searchUnitActions';
import './SearchUnitStandaloneHotelLayout.scss';

/* istanbul ignore next */
const mapStateToProps = () => ({});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    searchUnitActionsBound: bindActionCreators(searchUnitActions, dispatch),
  };
}

export class SearchUnitStandaloneHotelLayout extends Component {
  static propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      hash: PropTypes.string.isRequired,
      query: PropTypes.shape({
        state: PropTypes.string,
      }),
    }).isRequired,
    searchUnitActionsBound: PropTypes.shape({
      getSearchUnitData: PropTypes.func.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    const { searchUnitActionsBound, location } = this.props;
    searchUnitActionsBound.getSearchUnitData(location.query.state);
  }

  render() {
    return (
      <div className="search-unit-standalone-hotel-layout">
        <SearchUnitHeader title="Hotel Name Search" showIcon />
        <div className="search-unit-standalone-hotel-layout__inner">
          <SearchUnitHotelNameLayout />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchUnitStandaloneHotelLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/SearchUnitStandaloneHotelLayout/SearchUnitStandaloneHotelLayout.jsx
 **/